/* Back in stock dialog (Andre, 2026-09-06). Markup: snippets/pulse-back-in-stock.liquid.
   Styles: assets/pulse-back-in-stock.css. Opened by [data-pulse-notify-open] in
   sections/pulse-product.liquid.

   Three things this file does, in order:
   1. Portals the dialog to <body>. It is rendered inside <main>, which is a stacking
      context at z-index 1, so nothing inside it can paint over the fixed chrome
      whatever its own z-index (the size drawer and the quick-add sheet moved for the
      same reason). Done after parsing, never in the middle of it.
   2. Keeps the size words on the site's scale: the label's Women's/Men's span and every
      option's text follow window.PulseSizeScale, the one owner of that preference.
   3. Posts the form to Klaviyo's CLIENT API with the public key from the markup:
      a "Back in Stock Request" event carrying variant, market and the size label
      (the profile is created in the same call with first_name and the pulse_*
      stamps), then, when the opt-in is ticked, a Pulse List subscription. */
(function () {
  'use strict';

  var dlg = document.querySelector('[data-pulse-notify]');
  if (!dlg) return;

  var KLAVIYO = 'https://a.klaviyo.com/client/';
  var REVISION = '2025-07-15';
  var company = dlg.getAttribute('data-company') || '';
  var form = dlg.querySelector('[data-pulse-notify-form]');
  var done = dlg.querySelector('[data-pulse-notify-done]');
  var doneLine = dlg.querySelector('[data-pulse-notify-done-line]');
  var sizeEl = dlg.querySelector('[data-pulse-notify-size]');
  var errEl = dlg.querySelector('[data-pulse-notify-error]');
  var submitBtn = dlg.querySelector('[data-pulse-notify-submit]');
  var lastFocus = null;

  /* 1. portal ---------------------------------------------------------------- */
  function portal() {
    if (dlg.parentNode === document.body) return;
    document.body.appendChild(dlg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portal);
  else portal();

  /* 2. scale ----------------------------------------------------------------- */
  function applyGender(g) {
    dlg.setAttribute('data-pulse-gender', g);
    var segs = dlg.querySelectorAll('[data-pbis-gender]');
    for (var j = 0; j < segs.length; j++) {
      var on = segs[j].getAttribute('data-pbis-gender') === g;
      segs[j].classList.toggle('is-on', on);
      segs[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var attr = g === 'men' ? 'data-text-m' : 'data-text-w';
    var opts = dlg.querySelectorAll('option[data-text-w]');
    for (var i = 0; i < opts.length; i++) opts[i].textContent = opts[i].getAttribute(attr) || opts[i].textContent;
  }
  function gender() {
    var s = window.PulseSizeScale;
    return s && typeof s.gender === 'function' ? s.gender() : 'women';
  }
  if (window.PulseSizeScale && typeof window.PulseSizeScale.onChange === 'function') {
    applyGender(gender());
    window.PulseSizeScale.onChange(function () { applyGender(gender()); });
  }

  /* open / close ------------------------------------------------------------- */
  function preselect() {
    /* If the buy box already has a size chosen and that size is one a customer would
       wait for, carry it across so they do not pick it twice. */
    if (!sizeEl || sizeEl.tagName !== 'SELECT') return;
    var buy = document.querySelector('[data-pulse-sizeselect]');
    var chosen = buy && buy.options[buy.selectedIndex];
    if (!chosen || !chosen.value) return;
    var match = sizeEl.querySelector('option[value="' + chosen.value + '"]');
    if (match) sizeEl.value = chosen.value;
  }
  function showForm() {
    if (form) form.hidden = false;
    if (done) done.hidden = true;
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
  }
  function open() {
    if (!dlg.hidden) return;
    lastFocus = document.activeElement;
    showForm();
    preselect();
    dlg.hidden = false;
    document.body.classList.add('overflow-hidden');
    var first = sizeEl && sizeEl.tagName === 'SELECT' && !sizeEl.value ? sizeEl : form.querySelector('input[name="first_name"]');
    window.setTimeout(function () { if (first) first.focus(); }, 60);
  }
  function close() {
    if (dlg.hidden) return;
    if (document.activeElement && dlg.contains(document.activeElement)) document.activeElement.blur();
    dlg.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pulse-notify-open], [data-pulse-notify-close], [data-pbis-gender]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-pbis-gender')) {
      /* The click only SETS the preference; applyGender runs from onChange, the
         same contract every other surface keeps with PulseSizeScale. */
      var s = window.PulseSizeScale;
      if (s && typeof s.set === 'function') s.set(t.getAttribute('data-pbis-gender') === 'men' ? 'm' : 'w');
      else applyGender(t.getAttribute('data-pbis-gender'));
    } else if (t.hasAttribute('data-pulse-notify-open')) open();
    else close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !dlg.hidden) close();
    /* keep Tab inside the dialog while it is open */
    if (e.key === 'Tab' && !dlg.hidden) {
      var f = dlg.querySelectorAll('button:not([tabindex="-1"]):not([hidden]), input:not([type="hidden"]), select');
      var list = [];
      for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) list.push(f[i]);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* 3. submit ---------------------------------------------------------------- */
  function fail(msg) {
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    if (submitBtn) submitBtn.disabled = false;
  }
  function post(path, body) {
    return fetch(KLAVIYO + path + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    });
  }
  function chosenLabel() {
    if (!sizeEl || sizeEl.tagName !== 'SELECT') return '';
    var o = sizeEl.options[sizeEl.selectedIndex];
    if (!o) return '';
    return o.getAttribute(gender() === 'men' ? 'data-label-m' : 'data-label-w') || o.textContent.trim();
  }

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!company) { fail('Something went wrong. Please try again.'); return; }
    var nameEl = form.querySelector('input[name="first_name"]');
    var emailEl = form.querySelector('input[name="email"]');
    var first = nameEl ? nameEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';
    var variant = sizeEl ? sizeEl.value : '';
    [sizeEl, nameEl, emailEl].forEach(function (el) { if (el) el.classList.remove('is-invalid'); });
    /* WP4-H (2026-09-06): nameEl and emailEl were dereferenced unguarded in exactly the branch
       that fires when they are missing. If the markup ever changes shape the validation itself
       throws a TypeError inside the submit handler, which leaves the button disabled and the
       customer with no error line and no working form. Guarded like sizeEl already was. */
    if (!variant) { if (sizeEl) sizeEl.classList.add('is-invalid'); fail('Choose the size you are waiting for.'); return; }
    if (!first) { if (nameEl) nameEl.classList.add('is-invalid'); fail('Enter your first name.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (emailEl) emailEl.classList.add('is-invalid'); fail('Enter a valid email address.'); return; }

    if (submitBtn) submitBtn.disabled = true;
    if (errEl) errEl.hidden = true;

    var market = dlg.getAttribute('data-market') || '';
    var host = dlg.getAttribute('data-domain') || location.host;
    var url = 'https://' + host + (dlg.getAttribute('data-path') || '') + '?variant=' + variant;
    var props = {
      pulse_source: 'back-in-stock',
      pulse_market: market,
      pulse_domain: host,
      pulse_gender: gender(),
      pulse_bis_product: dlg.getAttribute('data-product') || '',
      pulse_bis_handle: dlg.getAttribute('data-handle') || '',
      pulse_bis_size: chosenLabel(),
      pulse_bis_variant: variant
    };
    /* THE REQUEST IS A CUSTOM EVENT, not Klaviyo's native back-in-stock
       subscription (Andre, 2026-09-06: "we have different stock for different
       markets"). The native trigger watches ONE global inventory number, so an
       Australian restock would email US customers. Instead the event carries
       the customer's market and the variant, and ~/pulse-project/klaviyo/
       back_in_stock_notifier.py watches pulse.market_state for THAT market and
       raises "Back in Stock Ready" for this profile when it flips to available.
       The same call creates or updates the profile with first_name and the
       pulse_* stamps the welcome routing reads. */
    var request = { data: { type: 'event', attributes: {
      properties: {
        variant_id: variant,
        product_id: dlg.getAttribute('data-product-id') || '',
        product_name: dlg.getAttribute('data-product') || '',
        handle: dlg.getAttribute('data-handle') || '',
        size_label: chosenLabel(),
        market: market,
        market_handle: dlg.getAttribute('data-market-handle') || '',
        domain: host,
        gender: gender(),
        url: url
      },
      metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Request' } } },
      profile: { data: { type: 'profile', attributes: { email: email, first_name: first, properties: props } } }
    } } };
    /* The promotional opt-in, ticked by default: an email-marketing subscription
       on Pulse List through the client subscriptions endpoint. Single opt-in
       list, so this is the same join the pop-ups make and the welcome flow
       fires from it. The restock request above never depends on this. */
    var optin = form.querySelector('[data-pulse-notify-optin]');
    var listId = dlg.getAttribute('data-list') || '';
    var subscribe = null;
    if (optin && optin.checked && listId) {
      /* WP4-H (2026-09-06). `props` is the SAME object the event's profile block above holds a
         reference to, and JSON.stringify runs later, at post() time -- so setting
         pulse_optin here leaked it into the "Back in Stock Request" event as well, marking
         every opted-in restock request as though the request itself were an opt-in. Clone
         before mutating, so the subscription carries the stamp and the event does not. */
      var optinProps = {};
      for (var k in props) { if (Object.prototype.hasOwnProperty.call(props, k)) optinProps[k] = props[k]; }
      optinProps.pulse_optin = 'back-in-stock';
      subscribe = { data: { type: 'subscription', attributes: {
        custom_source: 'Back in stock dialog',
        profile: { data: { type: 'profile', attributes: {
          email: email, first_name: first, properties: optinProps,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    }

    post('events/', request).then(function (r) {
      if (!r.ok) throw new Error('bis ' + r.status);
      /* The opt-in is a courtesy; its failure must not undo a request that landed. */
      if (subscribe) return post('subscriptions/', subscribe).catch(function () {});
    }).then(function () {
      if (doneLine) {
        var tpl = doneLine.getAttribute('data-template') || doneLine.textContent;
        doneLine.textContent = tpl.replace('[email]', email).replace('[size]', chosenLabel()).replace('[product]', dlg.getAttribute('data-product') || '');
      }
      if (form) form.hidden = true;
      if (done) done.hidden = false;
      if (submitBtn) submitBtn.disabled = false;
      var closeBtn = done && done.querySelector('[data-pulse-notify-close]');
      if (closeBtn) closeBtn.focus();
    }).catch(function () {
      fail('Something went wrong. Please try again.');
    });
  });
})();
